var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCloud = function SvgCloud(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "g3",
    width: 32,
    height: 21.1,
    viewBox: "0 0 32 21.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7",
    fill: "currentColor",
    d: "M19,11.9a2.241,2.241,0,0,0-1.9,1.2H5.3a3.7,3.7,0,0,1,0-7.4H7a5.274,5.274,0,0,1,.3-1.2c.1-.1.1-.3.2-.4a4.76,4.76,0,0,1,4.2-2.5,4.875,4.875,0,0,1,3.9,2,7.494,7.494,0,0,1,1.6-.5A6.22,6.22,0,0,0,11.7,0a6.537,6.537,0,0,0-6,4.1H5.3A5.357,5.357,0,0,0,0,9.5a5.271,5.271,0,0,0,5.3,5.3H17.2a2.041,2.041,0,0,0,3.9-.9A1.97,1.97,0,0,0,19,11.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    fill: "currentColor",
    d: "M25.6,7.8a7.368,7.368,0,0,0-6.5-4.1A7.286,7.286,0,0,0,12,9.5a5.81,5.81,0,0,0-4.1,2.4h8.7a3.034,3.034,0,0,1,2.5-1.2A3.244,3.244,0,0,1,22.3,14a3.2,3.2,0,0,1-5.7,2.1H6.9a5.786,5.786,0,0,0,5.6,5h13A6.509,6.509,0,0,0,32,14.5a6.643,6.643,0,0,0-6.4-6.7Z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cloud.21d599ff.svg";
export { ForwardRef as ReactComponent };